import { useTranslation } from "react-i18next";

import StarFullIcon from "src/core/assets/images/icons/starFull.svg?react";
import StarOutlineIcon from "src/core/assets/images/icons/starOutline.svg?react";
import { Button } from "src/core/components/ui/button";

export function FollowButtonField({
  isFollowing,
  onClick,
  loading = false,
}: {
  isFollowing: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div>
      {!isFollowing ? (
        <Button
          variant="outlinePrimary"
          size="small"
          onClick={onClick}
          className="gap-x-15"
          loading={loading}
        >
          <span>{t("form.createClient.follow")}</span>
          <StarOutlineIcon />
        </Button>
      ) : (
        <Button
          variant="destructive"
          size="small"
          onClick={onClick}
          className="gap-x-15"
          loading={loading}
        >
          <span>{t("form.createClient.followed")}</span>
          <StarFullIcon />
        </Button>
      )}
    </div>
  );
}
